/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_No_HistoryInputs */

const vi_order_no_history = /** @type {(inputs: Order_No_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có lịch sử thay đổi.`)
};

/**

* @param {Order_No_HistoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_no_history = /** @type {((inputs?: Order_No_HistoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_No_HistoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_no_history(inputs)
});